var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container section"},[_c('div',{staticClass:"row"},[_c('Map',{attrs:{"classNames":"col-md-7 col-sm-12 "}}),_c('ContactForm',{attrs:{"classNames":"col-md-5 col-sm-12"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }